export function strWidgetId(widgetId: number): string {
  return `${RUNTIME_KEY || 'w'}-${widgetId}`
}

export function widgetSelector(widgetId: number): string {
  return `getsitecontrol-widget[id="${strWidgetId(widgetId)}"]`
}

export function inlineWidgetSelector(widgetId: number): string {
  return `[data-${RUNTIME_KEY || 'w'}-inline~="${widgetId}"]`
}

export function findInlineWidgetPlaceholder(widgetId: number): Element | null {
  return document.querySelector(inlineWidgetSelector(widgetId))
}
